// webscm 2026 10 31 / Odoo 350449: переход «группа ссылок → список документов сегмента» — общий для панели поиска (Search.openRefsRow, Shift+F3)
// и вкладки References формы записи (AttrRefsTab). Шаги прежние (вынесены из Search.openRefsRow): globalRefsIds — СПИСОК id из графа, а не условие
// по полю (условие по табличной части штатным WHERE даёт пустой список без ошибки, ODOO-4114) → widget_open('widget-list').
//   route 'where' (панель поиска, как было) — фиксированный отбор doc.params.WHERE;
//   route 'chip'  (вкладка References) — снимаемый чипс CHIP-Where в doc.viewParams.dataSheet.CHIPS: снял чипс — весь сегмент. Проба на Demo7 31.10
//                 (product #6 → Sales Order Line, segment-1938): чипс — 106 строк = 106 id, чипс выключен — 3566 (весь сегмент); research/contract 350449.
// Строка «in» чипса — в КАНОНИЧЕСКОЙ форме чипсов (значения в attrs[].rightValue, rightValue строки — заглушка): так её читают AttrChips (_resolveTitle,
// utils/chipPickRow) и бэк (условие in берёт значения только из attrs). Голый массив в rightValue бэк тоже понимает, а чипсы фронта — нет; объект
// {value: [ids]} бэк превращает в «in ()» — ошибка SQL. Тест — tests/unit/refsTab.test.mjs
import { escapeHtml } from './sourceLink'

export const REFS_IDS_METHOD = 'globalRefsIds'

// чипс «Refers to: …» с отбором по списку id; заголовок — текстом (title) и экранированным HTML (meta.titleHTML: AttrChips рисует подпись через v-html)
export function refs_whereChip(ids, title, idsTitle) {
    const list = (Array.isArray(ids) ? ids : []).map(v => String(v))
    const text = String(title == null ? '' : title)
    return {
        segment: 'CHIP-Where',
        title: text,
        meta: { use: true, pi: 'pi-link', titleHTML: escapeHtml(text) },
        doc: {
            WHERE: [{
                use: true,
                leftValue: { value: 'id', valueStr: 'ID' },
                condition: 'in',
                rightValue: { value: '', valueStr: String(idsTitle == null ? '' : idsTitle) },
                attrs: list.map(id => ({ use: true, rightValue: { value: id, valueStr: id } })),
            }],
        },
    }
}

// fieldsMapping списка сегмента с отбором по id (см. route выше).
// webscm 2026 11 01 / Odoo 350449: opts.version — версия строк-источника (чипс рабочей коллекции вкладки References): строки work.records лежат в
// партициях версий, без doc.params.version список пуст (Demo7 01.11, товар #6 → TXN: 0 строк, с версией VERSION-plan-2026-10 — 38 = 38 id).
// Тот же ключ, что у «Records» строки сегмента (mainStore, get_currentRow_forParams). Пусто — без ключа: путь панели поиска прежний
export function refs_listFieldsMapping(source_segment, ids, opts = {}) {
    const fm = [{ leftValue: 'doc.params.segment', rightValue: source_segment }]
    const version = opts.version == null ? '' : String(opts.version).trim()
    if (version) fm.push({ leftValue: 'doc.params.version', rightValue: version })
    if (opts.route === 'chip') {
        fm.push({ leftValue: 'doc.viewParams.dataSheet.CHIPS', rightValue: { value: [refs_whereChip(ids, opts.chipTitle, opts.idsTitle)], valueAsIs: true } })
    } else {
        fm.push({ leftValue: 'doc.params.WHERE', rightValue: { value: [
            { use: true, leftValue: 'id', condition: 'in', rightValue: ids },
        ], valueAsIs: true } })
    }
    return fm
}

// почему ответу globalRefsIds нельзя верить ('' — можно): метода нет / граф не построен / ошибка бэка при пустом списке (как Search.refsUnavailableReason, ключ ids)
export function refs_idsUnavailableReason(answer, t) {
    const rows = answer && answer.ids
    if (!Array.isArray(rows)) {
        return t('Reference search is not available on this database — its backend does not support the reference graph')
    }
    if (answer.graph_ready === false) {
        return t('The reference graph is not built on this database yet — nothing to search in')
    }
    if (!rows.length && `${answer.TERMINAL || ''}`.includes('!!ERROR')) {
        return t('Failed to get references — the backend returned an error')
    }
    return ''
}

// globalRefsIds → список сегмента. opts: { route, chipTitle, idsTitle(n) → строка, parentAction, t, unavailable(answer) → причина,
// onUnavailable(reason), onOpened(answer), onDone(answer) — любой ответ (снять «открывается» у плашки) }
export function refs_openList(store, vueObj, params, opts = {}) {
    const t = typeof opts.t === 'function' ? opts.t : (s, p) => String(s).replace(/\{(\w+)\}/g, (m, k) => (p && k in p ? p[k] : m))
    const unavailable = typeof opts.unavailable === 'function' ? opts.unavailable : (answer) => refs_idsUnavailableReason(answer, t)
    store.executeBackendMethod(vueObj, { method: REFS_IDS_METHOD, params }, (answer) => {
        if (typeof opts.onDone === 'function') opts.onDone(answer)
        // «Документы не найдены» здесь было бы ложью: документы есть, спросить не у кого — причины те же, что у агрегата
        const reason = unavailable(answer)
        if (reason) {
            if (typeof opts.onUnavailable === 'function') opts.onUnavailable(reason)
            store.show_notification({ text: reason, status: 'error' })
            return
        }
        if (!answer.ids.length) {
            store.show_notification({ text: t('Documents not found'), status: 'warning' })
            return
        }
        if (answer.truncated) {
            // усечение не молчит: пользователь должен знать, что список неполный
            store.show_notification({
                text: t('Showing the first {count} of {total}', { count: answer.count, total: answer.count_total_title }),
                status: 'warning',
            })
        }
        const idsTitle = typeof opts.idsTitle === 'function' ? opts.idsTitle(answer.ids.length) : ''
        store.widget_open({
            widget: 'widget-list',
            parentAction: opts.parentAction,
            fieldsMapping: refs_listFieldsMapping(params.source_segment, answer.ids, { route: opts.route, chipTitle: opts.chipTitle, idsTitle, version: params.source_version }),
        }, vueObj)
        if (typeof opts.onOpened === 'function') opts.onOpened(answer)
    })
}
